import { render, staticRenderFns } from "./batch-update-label.vue?vue&type=template&id=363a48e2&scoped=true&"
import script from "./batch-update-label.vue?vue&type=script&lang=js&"
export * from "./batch-update-label.vue?vue&type=script&lang=js&"
import style0 from "./batch-update-label.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./batch-update-label.vue?vue&type=style&index=1&id=363a48e2&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363a48e2",
  null
  
)

export default component.exports